import { createFileRoute } from "@tanstack/react-router";

import { getUserHeadMeta } from "@/helpers/user-meta";
import { fetchWishlist } from "@/loaders/user-experiences";
import Games from "@/pages/user/games";

export const Route = createFileRoute("/@{$username}/wishlist/")({
  component: WishlistPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return {
      meta: [
        ...getUserHeadMeta(loaderData.user, "wishlist"),
        { content: "noindex", name: "robots" },
      ],
    };
  },
  loader: ({ params }) =>
    fetchWishlist({ data: { username: params.username } }),
});

function WishlistPage() {
  const data = Route.useLoaderData();
  if (!data) {
    return null;
  }
  return <Games {...data} />;
}
